import { NgModule } from '@angular/core';

import { LoginPageModule } from 'pages/login/login.module';
import { IntakeFormPageModule } from 'pages/intake-form/intake-form.module';
import { IntroCarouselPageModule } from 'pages/intro-carousel-page/intro-carousel-page.module';
import { ScheduleTipsPageModule } from 'pages/schedule/schedule-tips.module';
import { CliAuthPageModule } from 'pages/cli-auth/cli-auth.module';

const ONBOARDING_PAGE_MODULES = [
  LoginPageModule,
  IntakeFormPageModule,
  IntroCarouselPageModule,
  ScheduleTipsPageModule,
  CliAuthPageModule,
];

/**
 * The screens somebody sees before they are a fully set-up user: signing in,
 * the intake questionnaire, and the introduction.
 *
 * One of the app's per-area page groups: it only groups page modules together,
 * declaring nothing of its own and adding no providers. Why these files exist and
 * what keeps them honest: `design-docs/angular-components.md`, "Creating New
 * Components", step 4.
 */
@NgModule({
  imports: ONBOARDING_PAGE_MODULES,
  exports: ONBOARDING_PAGE_MODULES,
})
export class OnboardingPagesModule { }
